// extracted by mini-css-extract-plugin
export default {"cls1":"VeloSplitFab-Layout_cls1__Awupa","cls2":"VeloSplitFab-Layout_cls2__pJEV2 VeloSplitFab-Layout_cls1__Awupa"};